import template from "./notifications-count.html"
import {NotificationsService} from "../../Http/NotificationCenter/NotificationsService";

ko.components.register('notifications-count', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new NotificationsCount(params, widgetInfo);
        }
    }
});

export class NotificationsCount {
    constructor(params, widgetInfo) {
        this.params = params || {};
        this.notificationsService = new NotificationsService();
        this.afterHandoff = window.__wcpHomePerfHooks?.afterHandoff;

        this.count = ko.observable().publishOn($.cdh.topics.notifications.countValue);
        this.loading = ko.observable(true);
        this.error = ko.observable(false);
        ko.postbox.subscribe($.cdh.topics.notifications.countRefresh, () => {
            this.loading(true);
            this.load({ forceRefresh: true });
        });
        this.alertCountOnly = this.params.alertCountOnly || false;
        this.loadOnInit();
    }

    loadOnInit() {
        if (!this.alertCountOnly || typeof this.afterHandoff !== 'function') {
            this.load();
            return;
        }

        this.loading(false);
        this.afterHandoff(() => {
            this.loading(true);
            this.load();
        }, {
            interactionSelector: '.hdr-revamp-notification-icon, notifications-count.hdr-revamp-notification-badge, notifications-count.mobile-link-number',
        });
    }
    
    async load(options = {}) {
        if (this.alertCountOnly) {
            this.notificationsService.getAlertCountAsync(options).then((data) => {
                this.count(data.data());
            }).catch((error) => {
                this.error(true);
            }).finally(() => {
                this.loading(false);
            });
        }
        else {
            this.notificationsService.getCountAsync().then((data) => {
                this.count(data.data());
            }).catch((error) => {
                this.error(true);
            }).finally(() => {
                this.loading(false);
            });
        }
    }
}
